import { EntityApiService } from '@dfl/react-security';
import { IPaymentLog } from '../interfaces/IPaymentLog';

class PaymentLogsService extends EntityApiService<IPaymentLog> {}

export default new PaymentLogsService('/ms-pay/api/v1/payment-creation-logs');
